/**
 * Audio level subscription for the Public Transcription page.
 * Parallels usePublicRecordingWaveform but typed to the transcription service.
 */

import type { PublicTranscriptionService } from '@/lib/public-transcription-service';
import { useEffect, useState } from 'react';

export const usePublicTranscriptionWaveform = (
  serviceRef: React.MutableRefObject<PublicTranscriptionService | null>,
  isRecording: boolean,
  isPaused: boolean
) => {
  const [audioLevel, setAudioLevel] = useState(0);

  useEffect(() => {
    let unsubscribe: (() => void) | null = null;
    if (isRecording && !isPaused && serviceRef.current) {
      unsubscribe = serviceRef.current.onAudioLevelChange((level) => {
        setAudioLevel(level);
      });
    }
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [isRecording, isPaused, serviceRef]);

  useEffect(() => {
    if (!isRecording || isPaused) setAudioLevel(0);
  }, [isRecording, isPaused]);

  return { audioLevel };
};
